import { ReactElement } from "react";
import { useDataInputDialog } from "client/Hooks";
import { Dialog, Toolbar } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";

export type HubComposerUnsavedChangesDialogProps = {
	onClose(): void;
} & ({
	shouldShowSaveAsDraft: true;
	onConfirm(shouldSave: boolean): void;
} | {
	shouldShowSaveAsDraft: false;
	onConfirm(shouldSave: false): void;
});

export const HubComposerUnsavedChangesDialog = (
	props: HubComposerUnsavedChangesDialogProps
): ReactElement => {
	const {
		onConfirm,
		onClose,
		shouldShowSaveAsDraft
	} = props;

	return (
		<Dialog trackingId="hub-composer-unsaved-changes-dialog">
			<Dialog.Header
				title={localize("_AreYouSureYouWantToLeaveThisPage")}
			/>
			<Dialog.Body>
				<p>
					{localize("_YouHaveUnsavedChanges")}
				</p>
			</Dialog.Body>
			<Dialog.Footer>
				<Toolbar>
					{shouldShowSaveAsDraft && (
						<Toolbar.Button
							kind="primary"
							text={localize("_SaveAsDraft")}
							onClick={() => onConfirm(true)}
							trackingId="save"
						/>
					)}
					<Toolbar.Button
						kind={shouldShowSaveAsDraft ? "secondary" : "primary"}
						text={localize("_DiscardChanges")}
						onClick={() => onConfirm(false)}
						trackingId="discard-changes"
					/>
					<Toolbar.Button
						kind="secondary"
						text={localize("_Cancel")}
						onClick={onClose}
						trackingId="cancel"
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};
HubComposerUnsavedChangesDialog.displayName = "HubComposerUnsavedChangesDialog";

export type HubComposerUnsavedChangesDialogInitialData = Omit<
	HubComposerUnsavedChangesDialogProps,
	"onClose" | "onConfirm"
>;
export function useHubComposerUnsavedChangesDialog(): [
	element: ReactElement | null,
	open: (props: HubComposerUnsavedChangesDialogInitialData) => Promise<TryResult<boolean>>
] {
	return useDataInputDialog(
		(props, onClose, onConfirm) => (
			<HubComposerUnsavedChangesDialog
				{...props}
				onClose={onClose}
				onConfirm={onConfirm}
			/>
		)
	);
}
